import { useMemo } from 'react';
import { FeeTier } from '@velocity-exchange/sdk';
import { VOLUME_TIERS } from 'src/components/Modals/FeeTierModal/consts';
import useVelocityClient from 'src/hooks/useVelocityClient';

/**
 * The live perp fee tiers, one per rung of the program's tier ladder.
 *
 * `perpFeeStructure.feeTiers` is a fixed 10-slot array. Slots past the live
 * schedule are spares the program never selects, and they are not reliably
 * zeroed: an account initialised under an older schedule keeps whatever it was
 * given. So the ladder length decides how many slots are live, never a slot's
 * own contents.
 */
export default function usePerpFeeTiers(): FeeTier[] | undefined {
	const velocityClient = useVelocityClient();
	const allFeeTiers =
		velocityClient?.getStateAccount()?.perpFeeStructure?.feeTiers;

	return useMemo(
		() => allFeeTiers?.slice(0, VOLUME_TIERS.length),
		[allFeeTiers]
	);
}
